<p>help-youtube-competitor-checklist works!</p>
